module.exports = __webpack_public_path__ + "static/media/atenk.710cfbcf.jpg";